<template>

    <div class="pu_wrapper">

        <!--================ inc head top =================-->
        <inc_zadmin_head />
        <inc_zadmin_top />
        <inc_zadmin_title />
        <!--================ //inc head top =================-->

        <form id="regiForm">

            <div class="pu_board">
                <div class="pu_row">
                    <div class="pu_contents">

                        <!--================ inc left =================-->
                        <inc_zadmin_left />
                        <!--================ //inc left =================-->

                        <div class="pu_body">
                            <div class="pu_row">
                                <div class="pu_contents">

                                    <div class="pu_row">
                                        <div class="pu_contents">

                                            <table class="pu_table_view">

                                                <colgroup>
                                                    <col width="150px">
                                                    <col width="100px">
                                                    <col width="100%">
                                                    <col width="100%">
                                                    <col width="100px">
                                                    <col width="100%">
                                                    <col width="100%">
                                                </colgroup>

                                                <thead>
                                                    <tr>
                                                        <th rowspan="2">시세라인업</th>
                                                        <th colspan="3">사실 때</th>
                                                        <th colspan="3">파실 때</th>
                                                    </tr>
                                                    <tr>
                                                        <th>up/dw</th>
                                                        <th>변동가</th>
                                                        <th>현재가</th>
                                                        <th>up/dw</th>
                                                        <th>변동가</th>
                                                        <th>현재가</th>
                                                    </tr>
                                                </thead>
                                                <tbody>

                                                    <tr>
                                                        <th>24k 금시세</th>
                                                        <td>
                                                            <label class="pu_input_radio_label">
                                                                <input type="radio" name="buy_gold_24_gubun"
                                                                       class="pu_input_radio dev_input_must" value="U" v-model="view_1.BUY_GOLD_24_GUBUN" /> 상승
                                                            </label>
                                                            <br />
                                                            <label class="pu_input_radio_label">
                                                                <input type="radio" name="buy_gold_24_gubun"
                                                                       class="pu_input_radio dev_input_must" value="N" v-model="view_1.BUY_GOLD_24_GUBUN" /> 보합
                                                            </label>
                                                            <br />
                                                            <label class="pu_input_radio_label">
                                                                <input type="radio" name="buy_gold_24_gubun"
                                                                       class="pu_input_radio dev_input_must" value="D" v-model="view_1.BUY_GOLD_24_GUBUN" /> 하락
                                                            </label>
                                                        </td>
                                                        <td>
                                                            <label class="pu_input_text_label">
                                                                <input type="text" name="buy_gold_24_var" v-model="view_1.BUY_GOLD_24_VAR"
                                                                       class="pu_input_text dev_input_must dev_numnumnum"
                                                                       placeholder="" /><span>원</span>
                                                            </label>
                                                        </td>
                                                        <td>
                                                            <label class="pu_input_text_label">
                                                                <input type="text" name="buy_gold_24_now" v-model="view_1.BUY_GOLD_24_NOW"
                                                                       class="pu_input_text dev_input_must dev_numnumnum"
                                                                       placeholder="" /><span>원</span>
                                                            </label>
                                                        </td>
                                                        <td>
                                                            <label class="pu_input_radio_label">
                                                                <input type="radio" name="sell_gold_24_gubun"
                                                                       class="pu_input_radio dev_input_must" value="U" v-model="view_1.SELL_GOLD_24_GUBUN" /> 상승
                                                            </label>
                                                            <br />
                                                            <label class="pu_input_radio_label">
                                                                <input type="radio" name="sell_gold_24_gubun"
                                                                       class="pu_input_radio dev_input_must" value="N" v-model="view_1.SELL_GOLD_24_GUBUN" /> 보합
                                                            </label>
                                                            <br />
                                                            <label class="pu_input_radio_label">
                                                                <input type="radio" name="sell_gold_24_gubun"
                                                                       class="pu_input_radio dev_input_must" value="D" v-model="view_1.SELL_GOLD_24_GUBUN" /> 하락
                                                            </label>
                                                        </td>
                                                        <td>
                                                            <label class="pu_input_text_label">
                                                                <input type="text" name="sell_gold_24_var" v-model="view_1.SELL_GOLD_24_VAR"
                                                                       class="pu_input_text dev_input_must dev_numnumnum"
                                                                       placeholder="" /><span>원</span>
                                                            </label>
                                                        </td>
                                                        <td>
                                                            <label class="pu_input_text_label">
                                                                <input type="text" name="sell_gold_24_now" v-model="view_1.SELL_GOLD_24_NOW"
                                                                       class="pu_input_text dev_input_must dev_numnumnum"
                                                                       placeholder="" /><span>원</span>
                                                            </label>
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <th>18k 금시세</th>
                                                        <td>
                                                            <label class="pu_input_radio_label">
                                                                <input type="radio" name="buy_gold_18_gubun"
                                                                       class="pu_input_radio dev_input_must" value="U" v-model="view_1.BUY_GOLD_18_GUBUN" /> 상승
                                                            </label>
                                                            <br />
                                                            <label class="pu_input_radio_label">
                                                                <input type="radio" name="buy_gold_18_gubun"
                                                                       class="pu_input_radio dev_input_must" value="N" v-model="view_1.BUY_GOLD_18_GUBUN" /> 보합
                                                            </label>
                                                            <br />
                                                            <label class="pu_input_radio_label">
                                                                <input type="radio" name="buy_gold_18_gubun"
                                                                       class="pu_input_radio dev_input_must" value="D" v-model="view_1.BUY_GOLD_18_GUBUN" /> 하락
                                                            </label>
                                                        </td>
                                                        <td>
                                                            <label class="pu_input_text_label">
                                                                <input type="text" name="buy_gold_18_var" v-model="view_1.BUY_GOLD_18_VAR"
                                                                       class="pu_input_text dev_input_must dev_numnumnum"
                                                                       placeholder="" /><span>원</span>
                                                            </label>
                                                        </td>
                                                        <td>
                                                            <label class="pu_input_text_label">
                                                                <input type="text" name="buy_gold_18_now" v-model="view_1.BUY_GOLD_18_NOW"
                                                                       class="pu_input_text dev_input_must dev_numnumnum"
                                                                       placeholder="" /><span>원</span>
                                                            </label>
                                                        </td>
                                                        <td>
                                                            <label class="pu_input_radio_label">
                                                                <input type="radio" name="sell_gold_18_gubun"
                                                                       class="pu_input_radio dev_input_must" value="U" v-model="view_1.SELL_GOLD_18_GUBUN" /> 상승
                                                            </label>
                                                            <br />
                                                            <label class="pu_input_radio_label">
                                                                <input type="radio" name="sell_gold_18_gubun"
                                                                       class="pu_input_radio dev_input_must" value="N" v-model="view_1.SELL_GOLD_18_GUBUN" /> 보합
                                                            </label>
                                                            <br />
                                                            <label class="pu_input_radio_label">
                                                                <input type="radio" name="sell_gold_18_gubun"
                                                                       class="pu_input_radio dev_input_must" value="D" v-model="view_1.SELL_GOLD_18_GUBUN" /> 하락
                                                            </label>
                                                        </td>
                                                        <td>
                                                            <label class="pu_input_text_label">
                                                                <input type="text" name="sell_gold_18_var" v-model="view_1.SELL_GOLD_18_VAR"
                                                                       class="pu_input_text dev_input_must dev_numnumnum"
                                                                       placeholder="" /><span>원</span>
                                                            </label>
                                                        </td>
                                                        <td>
                                                            <label class="pu_input_text_label">
                                                                <input type="text" name="sell_gold_18_now" v-model="view_1.SELL_GOLD_18_NOW"
                                                                       class="pu_input_text dev_input_must dev_numnumnum"
                                                                       placeholder="" /><span>원</span>
                                                            </label>
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <th>14k 금시세</th>
                                                        <td>
                                                            <label class="pu_input_radio_label">
                                                                <input type="radio" name="buy_gold_14_gubun"
                                                                       class="pu_input_radio dev_input_must" value="U" v-model="view_1.BUY_GOLD_14_GUBUN" /> 상승
                                                            </label>
                                                            <br />
                                                            <label class="pu_input_radio_label">
                                                                <input type="radio" name="buy_gold_14_gubun"
                                                                       class="pu_input_radio dev_input_must" value="N" v-model="view_1.BUY_GOLD_14_GUBUN" /> 보합
                                                            </label>
                                                            <br />
                                                            <label class="pu_input_radio_label">
                                                                <input type="radio" name="buy_gold_14_gubun"
                                                                       class="pu_input_radio dev_input_must" value="D" v-model="view_1.BUY_GOLD_14_GUBUN" /> 하락
                                                            </label>
                                                        </td>
                                                        <td>
                                                            <label class="pu_input_text_label">
                                                                <input type="text" name="buy_gold_14_var" v-model="view_1.BUY_GOLD_14_VAR"
                                                                       class="pu_input_text dev_input_must dev_numnumnum"
                                                                       placeholder="" /><span>원</span>
                                                            </label>
                                                        </td>
                                                        <td>
                                                            <label class="pu_input_text_label">
                                                                <input type="text" name="buy_gold_14_now" v-model="view_1.BUY_GOLD_14_NOW"
                                                                       class="pu_input_text dev_input_must dev_numnumnum"
                                                                       placeholder="" /><span>원</span>
                                                            </label>
                                                        </td>
                                                        <td>
                                                            <label class="pu_input_radio_label">
                                                                <input type="radio" name="sell_gold_14_gubun"
                                                                       class="pu_input_radio dev_input_must" value="U" v-model="view_1.SELL_GOLD_14_GUBUN" /> 상승
                                                            </label>
                                                            <br />
                                                            <label class="pu_input_radio_label">
                                                                <input type="radio" name="sell_gold_14_gubun"
                                                                       class="pu_input_radio dev_input_must" value="N" v-model="view_1.SELL_GOLD_14_GUBUN" /> 보합
                                                            </label>
                                                            <br />
                                                            <label class="pu_input_radio_label">
                                                                <input type="radio" name="sell_gold_14_gubun"
                                                                       class="pu_input_radio dev_input_must" value="D" v-model="view_1.SELL_GOLD_14_GUBUN" /> 하락
                                                            </label>
                                                        </td>
                                                        <td>
                                                            <label class="pu_input_text_label">
                                                                <input type="text" name="sell_gold_14_var" v-model="view_1.SELL_GOLD_14_VAR"
                                                                       class="pu_input_text dev_input_must dev_numnumnum"
                                                                       placeholder="" /><span>원</span>
                                                            </label>
                                                        </td>
                                                        <td>
                                                            <label class="pu_input_text_label">
                                                                <input type="text" name="sell_gold_14_now" v-model="view_1.SELL_GOLD_14_NOW"
                                                                       class="pu_input_text dev_input_must dev_numnumnum"
                                                                       placeholder="" /><span>원</span>
                                                            </label>
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <th>백금시세</th>
                                                        <td>
                                                            <label class="pu_input_radio_label">
                                                                <input type="radio" name="buy_gold_white_gubun"
                                                                       class="pu_input_radio dev_input_must" value="U" v-model="view_1.BUY_GOLD_WHITE_GUBUN" /> 상승
                                                            </label>
                                                            <br />
                                                            <label class="pu_input_radio_label">
                                                                <input type="radio" name="buy_gold_white_gubun"
                                                                       class="pu_input_radio dev_input_must" value="N" v-model="view_1.BUY_GOLD_WHITE_GUBUN" /> 보합
                                                            </label>
                                                            <br />
                                                            <label class="pu_input_radio_label">
                                                                <input type="radio" name="buy_gold_white_gubun"
                                                                       class="pu_input_radio dev_input_must" value="D" v-model="view_1.BUY_GOLD_WHITE_GUBUN" /> 하락
                                                            </label>
                                                        </td>
                                                        <td>
                                                            <label class="pu_input_text_label">
                                                                <input type="text" name="buy_gold_white_var" v-model="view_1.BUY_GOLD_WHITE_VAR"
                                                                       class="pu_input_text dev_input_must dev_numnumnum"
                                                                       placeholder="" /><span>원</span>
                                                            </label>
                                                        </td>
                                                        <td>
                                                            <label class="pu_input_text_label">
                                                                <input type="text" name="buy_gold_white_now" v-model="view_1.BUY_GOLD_WHITE_NOW"
                                                                       class="pu_input_text dev_input_must dev_numnumnum"
                                                                       placeholder="" /><span>원</span>
                                                            </label>
                                                        </td>
                                                        <td>
                                                            <label class="pu_input_radio_label">
                                                                <input type="radio" name="sell_gold_white_gubun"
                                                                       class="pu_input_radio dev_input_must" value="U" v-model="view_1.SELL_GOLD_WHITE_GUBUN" /> 상승
                                                            </label>
                                                            <br />
                                                            <label class="pu_input_radio_label">
                                                                <input type="radio" name="sell_gold_white_gubun"
                                                                       class="pu_input_radio dev_input_must" value="N" v-model="view_1.SELL_GOLD_WHITE_GUBUN" /> 보합
                                                            </label>
                                                            <br />
                                                            <label class="pu_input_radio_label">
                                                                <input type="radio" name="sell_gold_white_gubun"
                                                                       class="pu_input_radio dev_input_must" value="D" v-model="view_1.SELL_GOLD_WHITE_GUBUN" /> 하락
                                                            </label>
                                                        </td>
                                                        <td>
                                                            <label class="pu_input_text_label">
                                                                <input type="text" name="sell_gold_white_var" v-model="view_1.SELL_GOLD_WHITE_VAR"
                                                                       class="pu_input_text dev_input_must dev_numnumnum"
                                                                       placeholder="" /><span>원</span>
                                                            </label>
                                                        </td>
                                                        <td>
                                                            <label class="pu_input_text_label">
                                                                <input type="text" name="sell_gold_white_now" v-model="view_1.SELL_GOLD_WHITE_NOW"
                                                                       class="pu_input_text dev_input_must dev_numnumnum"
                                                                       placeholder="" /><span>원</span>
                                                            </label>
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <th>은시세</th>
                                                        <td>
                                                            <label class="pu_input_radio_label">
                                                                <input type="radio" name="buy_gold_silver_gubun"
                                                                       class="pu_input_radio dev_input_must" value="U" v-model="view_1.BUY_GOLD_SILVER_GUBUN" /> 상승
                                                            </label>
                                                            <br />
                                                            <label class="pu_input_radio_label">
                                                                <input type="radio" name="buy_gold_silver_gubun"
                                                                       class="pu_input_radio dev_input_must" value="N" v-model="view_1.BUY_GOLD_SILVER_GUBUN" /> 보합
                                                            </label>
                                                            <br />
                                                            <label class="pu_input_radio_label">
                                                                <input type="radio" name="buy_gold_silver_gubun"
                                                                       class="pu_input_radio dev_input_must" value="D" v-model="view_1.BUY_GOLD_SILVER_GUBUN" /> 하락
                                                            </label>
                                                        </td>
                                                        <td>
                                                            <label class="pu_input_text_label">
                                                                <input type="text" name="buy_gold_silver_var" v-model="view_1.BUY_GOLD_SILVER_VAR"
                                                                       class="pu_input_text dev_input_must dev_numnumnum"
                                                                       placeholder="" /><span>원</span>
                                                            </label>
                                                        </td>
                                                        <td>
                                                            <label class="pu_input_text_label">
                                                                <input type="text" name="buy_gold_silver_now" v-model="view_1.BUY_GOLD_SILVER_NOW"
                                                                       class="pu_input_text dev_input_must dev_numnumnum"
                                                                       placeholder="" /><span>원</span>
                                                            </label>
                                                        </td>
                                                        <td>
                                                            <label class="pu_input_radio_label">
                                                                <input type="radio" name="sell_gold_silver_gubun"
                                                                       class="pu_input_radio dev_input_must" value="U" v-model="view_1.SELL_GOLD_SILVER_GUBUN" /> 상승
                                                            </label>
                                                            <br />
                                                            <label class="pu_input_radio_label">
                                                                <input type="radio" name="sell_gold_silver_gubun"
                                                                       class="pu_input_radio dev_input_must" value="N" v-model="view_1.SELL_GOLD_SILVER_GUBUN" /> 보합
                                                            </label>
                                                            <br />
                                                            <label class="pu_input_radio_label">
                                                                <input type="radio" name="sell_gold_silver_gubun"
                                                                       class="pu_input_radio dev_input_must" value="D" v-model="view_1.SELL_GOLD_SILVER_GUBUN" /> 하락
                                                            </label>
                                                        </td>
                                                        <td>
                                                            <label class="pu_input_text_label">
                                                                <input type="text" name="sell_gold_silver_var" v-model="view_1.SELL_GOLD_SILVER_VAR"
                                                                       class="pu_input_text dev_input_must dev_numnumnum"
                                                                       placeholder="" /><span>원</span>
                                                            </label>
                                                        </td>
                                                        <td>
                                                            <label class="pu_input_text_label">
                                                                <input type="text" name="sell_gold_silver_now" v-model="view_1.SELL_GOLD_SILVER_NOW"
                                                                       class="pu_input_text dev_input_must dev_numnumnum"
                                                                       placeholder="" /><span>원</span>
                                                            </label>
                                                        </td>
                                                    </tr>

                                                </tbody>
                                            </table>

                                        </div>
                                    </div>


                                    <div class="pu_row">
                                        <div class="pu_contents">

                                            <div class="pu_row_horizon">

                                                <div class="pu_col_lg_11"></div>

                                                <div class="pu_col_lg_1">
                                                    <a class="dev_btn_submit pu_btn pu_btn_regi">
                                                        <i class="fas fa-edit"></i> 저장
                                                    </a>
                                                </div>

                                            </div>

                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

        </form>

        <!--================ inc foot =================-->
        <inc_zadmin_foot />
        <!--================ //inc foot =================-->

    </div>

</template>

<script>
    // import
    import { mapGetters } from "vuex";
    import { mapActions } from "vuex";

    // export
    export default {

        computed: {

            ...mapGetters({
                getBase: "getBase"
            }),

        }

        , data() {
            return {

                gubun_page: "REGIFORM"

                , rownum: 0    // 번호
                , paging: ""   // 페이징

                , list_1: []
                , list_2: []
                , list_3: []
                , list_4: []

                , view_1: {}
                , view_2: {}
                , view_3: {}
                , view_4: {}

            }
        }

        , methods: {

            ...mapActions({
                setBase: "setBase"
            })

            // 진입점
            , init() {

                this.getViewData();

            }

            // 데이터 조회
            , getViewData () {

                var qs = this.$GetQueryMap();
                var data = {};
                data["gubun_page"] = this.gubun_page;

                // API 조회
                this.$SendPost("/vue_api/zadmin/set_price_gold/view", data, this.viewDataReturn);

            }

            // 데이터 리턴
            , viewDataReturn (data, err) {

                if (data) {

                    // 데이터 처리
                    if (data.RESULT_YN === "Y") {

                        this.view_1 = data.VIEW_1; // 뷰

                        // dimm 숨기기
                        this.$HideDimmLogo();

                    }

                }

            }

            // 저장
            , saveData () {

                // 24K --------------------------------------------------------

                var buy_gold_24_gubun = $("[name='buy_gold_24_gubun']:checked");
                if (buy_gold_24_gubun.length < 1) {
                    alert("24k 금시세 up/dw 를 선택해주세요");
                    $($("[name='buy_gold_24_gubun']")[0]).focus();
                    return false;
                }

                var buy_gold_24_var = $("[name='buy_gold_24_var']");
                if (!buy_gold_24_var.val().trim()) {
                    alert("24k 금시세 변동가를 입력해주세요");
                    buy_gold_24_var.focus();
                    return false;
                }

                var buy_gold_24_now = $("[name='buy_gold_24_now']");
                if (!buy_gold_24_now.val().trim()) {
                    alert("24k 금시세 현재가를 입력해주세요");
                    buy_gold_24_now.focus();
                    return false;
                }

                var sell_gold_24_gubun = $("[name='sell_gold_24_gubun']:checked");
                if (sell_gold_24_gubun.length < 1) {
                    alert("24k 금시세 up/dw 를 선택해주세요");
                    $($("[name='sell_gold_24_gubun']")[0]).focus();
                    return false;
                }

                var sell_gold_24_var = $("[name='sell_gold_24_var']");
                if (!sell_gold_24_var.val().trim()) {
                    alert("24k 금시세 변동가를 입력해주세요");
                    sell_gold_24_var.focus();
                    return false;
                }

                var sell_gold_24_now = $("[name='sell_gold_24_now']");
                if (!sell_gold_24_now.val().trim()) {
                    alert("24k 금시세 현재가를 입력해주세요");
                    sell_gold_24_now.focus();
                    return false;
                }

                // 18K --------------------------------------------------------

                var buy_gold_18_gubun = $("[name='buy_gold_18_gubun']:checked");
                if (buy_gold_18_gubun.length < 1) {
                    alert("18k 금시세 up/dw 를 선택해주세요");
                    $($("[name='buy_gold_18_gubun']")[0]).focus();
                    return false;
                }

                var buy_gold_18_var = $("[name='buy_gold_18_var']");
                if (!buy_gold_18_var.val().trim()) {
                    alert("18k 금시세 변동가를 입력해주세요");
                    buy_gold_18_var.focus();
                    return false;
                }

                var buy_gold_18_now = $("[name='buy_gold_18_now']");
                if (!buy_gold_18_now.val().trim()) {
                    alert("18k 금시세 현재가를 입력해주세요");
                    buy_gold_18_now.focus();
                    return false;
                }

                var sell_gold_18_gubun = $("[name='sell_gold_18_gubun']:checked");
                if (sell_gold_18_gubun.length < 1) {
                    alert("18k 금시세 up/dw 를 선택해주세요");
                    $($("[name='sell_gold_18_gubun']")[0]).focus();
                    return false;
                }

                var sell_gold_18_var = $("[name='sell_gold_18_var']");
                if (!sell_gold_18_var.val().trim()) {
                    alert("18k 금시세 변동가를 입력해주세요");
                    sell_gold_18_var.focus();
                    return false;
                }

                var sell_gold_18_now = $("[name='sell_gold_18_now']");
                if (!sell_gold_18_now.val().trim()) {
                    alert("18k 금시세 현재가를 입력해주세요");
                    sell_gold_18_now.focus();
                    return false;
                }

                // 14K --------------------------------------------------------

                var buy_gold_14_gubun = $("[name='buy_gold_14_gubun']:checked");
                if (buy_gold_14_gubun.length < 1) {
                    alert("14k 금시세 up/dw 를 선택해주세요");
                    $($("[name='buy_gold_14_gubun']")[0]).focus();
                    return false;
                }

                var buy_gold_14_var = $("[name='buy_gold_14_var']");
                if (!buy_gold_14_var.val().trim()) {
                    alert("14k 금시세 변동가를 입력해주세요");
                    buy_gold_14_var.focus();
                    return false;
                }

                var buy_gold_14_now = $("[name='buy_gold_14_now']");
                if (!buy_gold_14_now.val().trim()) {
                    alert("14k 금시세 현재가를 입력해주세요");
                    buy_gold_14_now.focus();
                    return false;
                }

                var sell_gold_14_gubun = $("[name='sell_gold_14_gubun']:checked");
                if (sell_gold_14_gubun.length < 1) {
                    alert("14k 금시세 up/dw 를 선택해주세요");
                    $($("[name='sell_gold_14_gubun']")[0]).focus();
                    return false;
                }

                var sell_gold_14_var = $("[name='sell_gold_14_var']");
                if (!sell_gold_14_var.val().trim()) {
                    alert("14k 금시세 변동가를 입력해주세요");
                    sell_gold_14_var.focus();
                    return false;
                }

                var sell_gold_14_now = $("[name='sell_gold_14_now']");
                if (!sell_gold_14_now.val().trim()) {
                    alert("14k 금시세 현재가를 입력해주세요");
                    sell_gold_14_now.focus();
                    return false;
                }

                // white --------------------------------------------------------

                var buy_gold_white_gubun = $("[name='buy_gold_white_gubun']:checked");
                if (buy_gold_white_gubun.length < 1) {
                    alert("백금시세 up/dw 를 선택해주세요");
                    $($("[name='buy_gold_white_gubun']")[0]).focus();
                    return false;
                }

                var buy_gold_white_var = $("[name='buy_gold_white_var']");
                if (!buy_gold_white_var.val().trim()) {
                    alert("백금시세 변동가를 입력해주세요");
                    buy_gold_white_var.focus();
                    return false;
                }

                var buy_gold_white_now = $("[name='buy_gold_white_now']");
                if (!buy_gold_white_now.val().trim()) {
                    alert("백금시세 현재가를 입력해주세요");
                    buy_gold_white_now.focus();
                    return false;
                }

                var sell_gold_white_gubun = $("[name='sell_gold_white_gubun']:checked");
                if (sell_gold_white_gubun.length < 1) {
                    alert("백금시세 up/dw 를 선택해주세요");
                    $($("[name='sell_gold_white_gubun']")[0]).focus();
                    return false;
                }

                var sell_gold_white_var = $("[name='sell_gold_white_var']");
                if (!sell_gold_white_var.val().trim()) {
                    alert("백금시세 변동가를 입력해주세요");
                    sell_gold_white_var.focus();
                    return false;
                }

                var sell_gold_white_now = $("[name='sell_gold_white_now']");
                if (!sell_gold_white_now.val().trim()) {
                    alert("백금시세 현재가를 입력해주세요");
                    sell_gold_white_now.focus();
                    return false;
                }

                // silver --------------------------------------------------------

                var buy_gold_silver_gubun = $("[name='buy_gold_silver_gubun']:checked");
                if (buy_gold_silver_gubun.length < 1) {
                    alert("은시세 up/dw 를 선택해주세요");
                    $($("[name='buy_gold_silver_gubun']")[0]).focus();
                    return false;
                }

                var buy_gold_silver_var = $("[name='buy_gold_silver_var']");
                if (!buy_gold_silver_var.val().trim()) {
                    alert("은시세 변동가를 입력해주세요");
                    buy_gold_silver_var.focus();
                    return false;
                }

                var buy_gold_silver_now = $("[name='buy_gold_silver_now']");
                if (!buy_gold_silver_now.val().trim()) {
                    alert("은시세 현재가를 입력해주세요");
                    buy_gold_silver_now.focus();
                    return false;
                }

                var sell_gold_silver_gubun = $("[name='sell_gold_silver_gubun']:checked");
                if (sell_gold_silver_gubun.length < 1) {
                    alert("은시세 up/dw 를 선택해주세요");
                    $($("[name='sell_gold_silver_gubun']")[0]).focus();
                    return false;
                }

                var sell_gold_silver_var = $("[name='sell_gold_silver_var']");
                if (!sell_gold_silver_var.val().trim()) {
                    alert("은시세 변동가를 입력해주세요");
                    sell_gold_silver_var.focus();
                    return false;
                }

                var sell_gold_silver_now = $("[name='sell_gold_silver_now']");
                if (!sell_gold_silver_now.val().trim()) {
                    alert("은시세 현재가를 입력해주세요");
                    sell_gold_silver_now.focus();
                    return false;
                }

                if (confirm(INFO_CONF_SAVE)) {

                    // dimm 보이기
                    this.$ShowDimmLogo();

                    var data = this.$FormToMap($('#regiForm'));
                    data["gubun_page"] = this.gubun_page;

                    // API 조회
                    this.$SendPost("/vue_api/zadmin/set_price_gold/save", data, this.saveEventReturn);

                }

            }

            // 저장 데이터
            , saveEventReturn (data, err) {

                // dimm 숨기기
                this.$HideDimmLogo();

            }

        }

        , beforeCreate() {
        }

        , created() {
        }

        , beforeMount() {
        }

        , mounted() {
            this.$AfterMounted(this);
        }

        , beforeUpdate() {
        }

        , updated() {
            this.$AfterUpdated(this);
        }

        , beforeDestroy() {
        }

        , destroyed() {
        }

    }

</script>